<template>
  <div class="handleDataDownload">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="110px"
        >
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="formInline.title"
              maxlength="50"
              style="width: 370px"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="url">
            <el-upload
              ref="upload"
              :limit="1"
              :format="['rar', 'zip', 'pdf', 'doc', 'xls', 'psd', 'jpg', 'txt']"
              accept=".rar, .RAR, .zip, .ZIP, .pdf, .PDF, .doc, .DOC, .xls, .XLS, .psd, .PSD, .jpg, .JPG, .txt, .TXT"
              :action="uploadHost"
              :data="uploadData"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :clearFiles="clearFiles"
              :file-list="file_list"
              :on-error="handleFormatError"
            >
              <el-button slot="trigger" size="small" type="primary"
                >上传文件</el-button
              >
              <div slot="tip" class="el-upload__tip">
                支持.RAR、.ZIP、.PDF、.DOC、.XLS、.PSD、.JPG、.TXT格式文件
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  addCmsDocument,
  updateCmsDocument,
} from "@/api/marketingAdmin/dataDownload.js";
export default {
  data() {
    return {
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      file_list: [],
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        title: "",
        url: "",
        ram: "",
        type: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        url: [{ required: true, message: "请上传附件" }],
      },
      status: "",
    };
  },
  watch: {
    "formInline.url": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("url");
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // 初始化
    init(status, payload) {
      Object.assign(this.$data, this.$options.data());
      this.file_list = [];
      this.status = status;
      this.dialogTitle = status === "add" ? "新建文件资料" : "编辑文件资料";
      if (status === "alter") {
        Object.keys(this.formInline).forEach((item) => {
          this.formInline[item] = payload[item];
        });
        this.formInline.id = payload.id;
        this.file_list = [
          { name: `${payload.title}.${payload.type}`, url: payload.url },
        ];
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.status === "add") {
            addCmsDocument({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateCmsDocument({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
    beforeUpload(file) {
      let fileName = file.name;
      this.formInline.type = fileName.substring(fileName.lastIndexOf(".") + 1);
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.formInline.url = res.data;
            this.formInline.ram = file.size;
            this.fileData.fileUrl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
      this.file_list = [];
    },
    handleRemove() {
      this.formInline.url = "";
      this.formInline.type = "";
      this.formInline.ram = "";
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.handleDataDownload {
}
</style>